import React from 'react'
import lineImg from "../../../../../Assets/nokaoi-imges/heading-line.png"
import { Image } from 'react-bootstrap'

const Heading = ({children, className="text-center"}) => {
  return (
    <div className={`heading-wrapper ${className}`}>
        {children}
        <Image src={lineImg} alt='Heading Line'/>
    </div>
  )
}

export default Heading